"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_safe_src_doc_iframe_1 = tslib_1.__importDefault(require("react-safe-src-doc-iframe"));
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../comps/reusables");
const InviteButton_1 = tslib_1.__importDefault(require("./InviteButton"));
const react_2 = require("@osmosys/react");
// interface IRefs {
//   [key: string]: {
//     current: HTMLIFrameElement;
//   };
// }
class Invites extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.inviteRefs = {};
        this.state = {
            errorToShow: '',
            invites: {},
        };
    }
    componentDidUpdate(props) {
        this.addInvitesToState(props.user.invites);
    }
    addInvitesToState(data) {
        if (!data ||
            Object.keys(data).length === 0 ||
            !data[0] ||
            !data[0].user ||
            !data[0].user.invites ||
            data[0].user.invites.length === 0) {
            return;
        }
        const invites = data.reduce((accum, invite) => {
            return Object.assign({ [invite.id]: Object.assign(Object.assign({}, invite), { previewModalIsOpen: false }) }, accum);
        }, {});
        this.setState({
            invites,
        });
    }
    render() {
        return (react_1.default.createElement(reusables_1.SmallCenteredLayout, null,
            react_1.default.createElement(react_2.OsmosysModal, { osysName: "UserInvites", osysSubType: "error", isOpen: this.state.errorToShow !== '', toggle: () => {
                    this.setState({
                        errorToShow: '',
                    });
                }, centered: true, body: true },
                react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: () => {
                        this.setState({
                            errorToShow: '',
                        });
                    } }, "Invite send error"),
                react_1.default.createElement(reactstrap_1.ModalBody, null,
                    react_1.default.createElement("textarea", { className: "w-100 border-0", style: { height: 300 } }, String(this.state.errorToShow)))),
            this.props.user.invites.length === 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, "No invites"),
                react_1.default.createElement(InviteButton_1.default, { color: "dark", userId: this.props.user.id, invites: this.props.user.invites, acceptedInvite: !!this.props.user.acceptedInvite, hasPassword: this.props.user.hasPassword }))),
            this.props.user.invites
                .sort((a, b) => b.id - a.id)
                .map((i, index) => {
                const isAcceptedInvite = this.props.user.acceptedInvite &&
                    this.props.user.acceptedInvite.id === i.id;
                const isValid = this.props.user.latestInvitation &&
                    this.props.user.latestInvitation.id === i.id;
                return (react_1.default.createElement(react_1.default.Fragment, { key: i.id },
                    react_1.default.createElement(reactstrap_1.Card, { className: "mb-3" },
                        react_1.default.createElement(reactstrap_1.CardHeader, null,
                            react_1.default.createElement("h4", { className: "mb-0" },
                                "Invitation #",
                                this.props.user.invites.length - index)),
                        react_1.default.createElement(reactstrap_1.CardBody, null,
                            i.error && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(reactstrap_1.Alert, { color: "danger", className: "mb-2 mt-0" },
                                    "There was an error emailing this invitation. You may need to send another invitation.",
                                    ' ',
                                    react_1.default.createElement("a", { href: "#", onClick: () => {
                                            this.setState({
                                                errorToShow: i.error,
                                            });
                                        } }, "Show error.")))),
                            react_1.default.createElement(reactstrap_1.Table, { borderless: true, className: "mb-0" },
                                react_1.default.createElement("thead", { className: "d-none" },
                                    react_1.default.createElement("tr", null,
                                        react_1.default.createElement("th", { colSpan: 2 }, "History"))),
                                react_1.default.createElement("tbody", null,
                                    react_1.default.createElement("tr", null,
                                        react_1.default.createElement("td", null,
                                            react_1.default.createElement("strong", null, "Sent")),
                                        react_1.default.createElement("td", null,
                                            moment_1.default(i.createdAt).format('LLLL'),
                                            ".")),
                                    i.usedToSignupAt && (react_1.default.createElement("tr", null,
                                        react_1.default.createElement("td", null,
                                            react_1.default.createElement("strong", null, "Used to create account")),
                                        react_1.default.createElement("td", null,
                                            react_1.default.createElement("strong", null, moment_1.default(i.usedToSignupAt).format('LLLL')))))))),
                        react_1.default.createElement(reactstrap_1.CardFooter, { className: "justify-content-between d-flex" },
                            react_1.default.createElement(reactstrap_1.Button, { disabled: true, outline: true, size: "sm", color: isAcceptedInvite
                                    ? 'success'
                                    : isValid
                                        ? 'success'
                                        : 'danger' }, isAcceptedInvite
                                ? 'Accepted'
                                : isValid
                                    ? 'Valid'
                                    : 'Expired'),
                            react_1.default.createElement(reactstrap_1.Button, { size: "sm", color: "dark", onClick: () => {
                                    this.setState({
                                        invites: Object.assign(Object.assign({}, this.state.invites), { [i.id]: Object.assign(Object.assign({}, this.state.invites[i.id]), { previewModalIsOpen: true }) }),
                                    });
                                } }, "Preview"))),
                    react_1.default.createElement(react_2.OsmosysModal, { osysName: "UserInvites", osysSubType: "preview", size: "lg", centered: true, isOpen: this.state.invites[i.id] &&
                            this.state.invites[i.id].previewModalIsOpen, toggle: () => {
                            this.setState({
                                invites: Object.assign(Object.assign({}, this.state.invites), { [i.id]: Object.assign(Object.assign({}, this.state.invites[i.id]), { previewModalIsOpen: false }) }),
                            });
                        } },
                        react_1.default.createElement(reactstrap_1.ModalHeader, null, "Email preview"),
                        react_1.default.createElement(reactstrap_1.ModalBody, null, this.state.invites[i.id] &&
                            this.state.invites[i.id].previewModalIsOpen && (react_1.default.createElement(react_safe_src_doc_iframe_1.default, { ref: r => (this.inviteRefs[i.id] = r), className: "border rounded w-100 mb-0 d-block", style: { height: 400 }, srcDoc: i.emailHtml }))),
                        react_1.default.createElement(reactstrap_1.ModalFooter, null,
                            react_1.default.createElement(reactstrap_1.Button, { color: "light", className: "w-100", target: "_blank", download: true, tag: "a", href: `data:text/html;charset=UTF-8,${encodeURIComponent(i.emailHtml)}` }, "Download invitation")))));
            })));
    }
}
exports.default = Invites;
//# sourceMappingURL=index.js.map